import { useEffect, useRef } from "react";

/**
 * Adds the "in" class to any descendant marked with one of the reveal classes
 * once it intersects the viewport — driving every entrance animation.
 */
const REVEAL_SELECTOR =
  ".reveal, .reveal-img, .slide-left, .slide-right, .slide-up-lg, .fly-in, .char";

export default function useReveal(options = {}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const targets = el.querySelectorAll(REVEAL_SELECTOR);

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      {
        threshold: options.threshold ?? 0.12,
        rootMargin: options.rootMargin ?? "0px 0px -40px 0px",
      }
    );

    targets.forEach((t) => io.observe(t));
    if (
      el.classList?.contains("reveal") ||
      el.classList?.contains("slide-left") ||
      el.classList?.contains("slide-right") ||
      el.classList?.contains("slide-up-lg") ||
      el.classList?.contains("reveal-img")
    ) {
      io.observe(el);
    }

    return () => io.disconnect();
  }, [options.threshold, options.rootMargin]);

  return ref;
}
